import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';
const { getAllowCookies } = require('./../cookieUtils');

const { getRank } = require('./../rankedUtils');
const { state } = require('./../state');

import { FaShare, FaAngleUp, FaAngleDown } from 'react-icons/fa';

class RankedDisplayWidget extends React.Component {

    constructor() {
        super();
        
        this.state = { rank: 0, mmr: 0, hasData: false };
    }

    componentDidMount() {

        if (getAllowCookies()) {
            const me = this;
            const callBack = function(data) {
                me.setState({ rank: data.rank, mmr: data.mmr, hasData: true });
            }

            getRank(callBack);
        }
    }

    genMain(numb) {

        const icon = (<FaAngleUp/>);
        const c = "redtext";

        return (
            <div class={c}>
                {numb} {icon}
            </div>
        );
    }

    render() {
        if (!this.state.hasData || !getAllowCookies() || !state.userId || state.userId.length == 0)
            return (<div></div>);

        return (
            <div class="rankedDisplayWidget">
                <table>
                    <tr>
                        <td>
                            <div class="">
                                Rank<br/>
                                { this.genMain(this.state.rank) }
                            </div>
                        </td>
                        <td>
                            <div class="">
                                MMR<br/>
                                { this.genMain(this.state.mmr) }
                            </div>
                        </td>
                    </tr>

                </table>
            </div>
        );
    }

}

RankedDisplayWidget.propTypes = {

};

export default RankedDisplayWidget;